module.exports = __webpack_public_path__ + "img/home_bg.92e6f7c8.jpg";